<template>
    <fragment>
        <InsideHeader :title="pageData.title" :bredcrumb="breadcrumb" />
        <section class="about-us-area">
            <div class="container">
                <div class="row align-items-center">
                    <!--Why Choose Content and Image box Start-->
                    <div class="col-12 col-sm-12 col-md-12">
                        <div class="about-us-content">
                            <h2 class="section-heading" v-if="pageData.page_heading">{{ pageData.page_heading }}</h2>
                            <p class="section-subheading" v-if="pageData.subheading">{{ pageData.subheading }}</p>
                            <div v-html="pageData.content" v-if="pageData.content"></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
    </fragment>
</template>

<script>
import InsideHeader from "@/components/InsideHeader.vue";

export default {
    components: {InsideHeader},
    data() {
        return {
            title: this.$route.meta.title,
            breadcrumb: [
                {title: 'Home', path:'/'}
            ], 
            pageData: [],
            page: this.$route.meta.slug
        }
    },
    methods: {
        getData(){
            this.$http.get(`/${this.page}`).then(res=>{ 
                if(res.status === 200 && res.data.page_data){
                    this.pageData = res.data.page_data
                    this.breadcrumb.push({
                        title: this.pageData.title,
                        path: '#'
                    })
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>